// extracted by css-extract-rspack-plugin
export default {"appleImageBox":"StoreButton-module__appleImageBox__VX016l_","googleImageBox":"StoreButton-module__googleImageBox__WEwIt9j"};